import React from 'react';

import trans from 'common/tools/translations/trans';

import ReviewLink from 'website/components/opinion/ReviewLink';

type Props = {
  entityId: string;
};

export const ReviewStatusDenied: React.FC<Props> = ({ entityId }) => (
  <div className="review-card-bam-message">
    <div className="review-card-message-status">
      {trans('bam.rejected-review')}
    </div>
    <div className="review-card-bam-cta">
      <ReviewLink
        entityId={entityId}
        showLabel={true}
        showIcon={false}
        label={trans('bam.edit-my-review')}
        className="review-link-bam"
      />
    </div>
  </div>
);

export const ReviewStatusBlocked: React.FC<Props> = ({ entityId }) => (
  <div className="review-card-bam-message">
    <div className="review-card-message-status">
      {trans('bam.blocked-review')}
    </div>
    <div className="review-card-bam-cta">
      <ReviewLink
        entityId={entityId}
        showLabel={true}
        showIcon={false}
        label={trans('bam.delete-review')}
        className="review-link-bam"
      />
    </div>
  </div>
);
